import React from "react";
import BaseInput from "./BaseInput";

const TextInput = (props) => {
    return (
      <BaseInput type="text" {...props} />
    );
};

export default TextInput;